module.exports = __webpack_public_path__ + "static/img/submitted_successfully.60d7a71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/icon/submitted_successfully.svg
// module id = a0rY
// module chunks = 11